const env = window.location.href

 console.log('------> index.js env=' + env.toLowerCase())


if (env.toLowerCase().indexOf('http://') != -1) {
  console.log('-----> on local')
  module.exports = require('./config.local')

} else if (env.toLowerCase().indexOf('dev.usps.gov') != -1 || env.toLowerCase().indexOf('eagnmnwbd196') != -1 || env.toLowerCase().indexOf('eagnmnwbd197') != -1) {
  console.log('-----> on DEV')
  module.exports = require('./config.dev')

} else if (env.toLowerCase().indexOf('test') != -1 || env.toLowerCase().indexOf('eagnmntwe1cdd') != -1 || env.toLowerCase().indexOf('eagnmntwe1c69') != -1) {
  console.log('on SIT')
  module.exports = require('./config.sit')

} else if (env.toLowerCase().indexOf('cat') != -1 || env.toLowerCase().indexOf('eagnmnss3fa') != -1 || env.toLowerCase().indexOf('eagnmnss3fb') != -1) {
  console.log('-----> on CAT')
  module.exports = require('./config.cat')

} else if (env.toLowerCase().indexOf('dangerousgoods.usps.gov') != -1 || env.toLowerCase().indexOf('eagnmnwbp13c1') != -1 || env.toLowerCase().indexOf('eagnmnwbp13c2') != -1) {
  console.log('-----> on PROD Internal')
  module.exports = require('./config.production')

} else if (env.toLowerCase().indexOf('dangerousgoods.usps.com') != -1 || env.toLowerCase().indexOf('eagnmntwe1e4b') != -1 || env.toLowerCase().indexOf('eagnmntwe1e4d') != -1 || env.toLowerCase().indexOf('eagnmntwe1e4c') != -1 || env.toLowerCase().indexOf('eagnmntwe1e4e') != -1) {
  console.log('-----> on PROD External')
  module.exports = require('./config.production-ext')
}
